import { z } from 'zod';

import { BasePType } from './base';
import { PTypes } from './index';

export const baseFooter = BasePType.extend({
  type: z.enum(['footer']),
});

export type Footer = z.infer<typeof baseFooter> & {
  baseFooter?: PTypes[];
};

export const Footer: z.ZodType<Footer> = baseFooter.extend({
  nestedContentContainers: z.lazy(() => z.array(PTypes)).optional(),
});
